import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import * as style from './style.css';
import { Flats } from './parts/Flats/';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Plan = function Plan(_ref) {
  var floorPlanUrl = _ref.floorPlanUrl,
    flats = _ref.flats,
    onFlatOpen = _ref.onFlatOpen,
    onFlatHover = _ref.onFlatHover,
    hoveredFlatPlanId = _ref.hoveredFlatPlanId;
  var imageRef = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loaded = _React$useState2[0],
    setLoaded = _React$useState2[1];
  var _React$useState3 = React.useState({
      width: 0,
      height: 0
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    _React$useState4$ = _React$useState4[0],
    width = _React$useState4$.width,
    height = _React$useState4$.height,
    setImageSize = _React$useState4[1];
  var _React$useState5 = React.useState({
      realWidth: 0,
      realHeight: 0
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    _React$useState6$ = _React$useState6[0],
    realWidth = _React$useState6$.realWidth,
    realHeight = _React$useState6$.realHeight,
    setImageRealSize = _React$useState6[1];
  var handleImageLoaded = React.useCallback(function () {
    var img = imageRef.current;
    if (img) {
      setLoaded(true);
      setImageSize({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
      setImageRealSize({
        realWidth: img.clientWidth,
        realHeight: img.clientHeight
      });
    }
  }, []);
  React.useEffect(function () {
    if (imageRef.current && imageRef.current.complete) {
      handleImageLoaded();
    }
  }, [handleImageLoaded]);
  React.useLayoutEffect(function () {
    function updateImageWidth() {
      var _imageRef$current;
      if ((_imageRef$current = imageRef.current) !== null && _imageRef$current !== void 0 && _imageRef$current.clientWidth) {
        setImageRealSize({
          realWidth: imageRef.current.clientWidth,
          realHeight: imageRef.current.clientHeight
        });
      }
    }
    window.addEventListener('resize', updateImageWidth);
    updateImageWidth();
    return function () {
      return window.removeEventListener('resize', updateImageWidth);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    "data-testid": "Plan",
    children: /*#__PURE__*/_jsxs("div", {
      className: style['inner'],
      children: [/*#__PURE__*/_jsx("img", {
        className: style['plan-image'],
        ref: imageRef,
        src: floorPlanUrl,
        onLoad: handleImageLoaded,
        alt: "\u041F\u043B\u0430\u043D \u044D\u0442\u0430\u0436\u0430"
      }), /*#__PURE__*/_jsx("svg", {
        id: "flat-svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 ".concat(width, " ").concat(height)
      }), loaded && /*#__PURE__*/_jsx(Flats, {
        flats: flats,
        hoveredFlatPlanId: hoveredFlatPlanId,
        containerWidth: width,
        containerHeight: height,
        realWidth: realWidth,
        realHeight: realHeight,
        onFlatOpen: onFlatOpen,
        onFlatHover: onFlatHover
      })]
    })
  });
};